import { token } from "./token"
import { games } from "./games"
import { users } from "./users"
import { tags } from "./tags"
import { wrds } from "./wrds"
import { commits } from "./commits"
import { contributors } from "./contributors"
import { consignas } from "./consignas"
import { system } from "./system"
import { stories } from "./stories"
import { suggestions } from "./suggestions"
import { game_management } from "./game_management"
import { qa } from "./qa"

let api = {
  token,
  games,
  users,
  wrds,
  tags,
  commits,
  contributors,
  consignas,
  system,
  stories,
  suggestions,
  game_management,
  qa,
}

export { api }
